import { style } from "@vanilla-extract/css";

import { theme } from "../../theme/css/theme.css";
import { responsive } from "../../utils/responsive";

export const containerStyle = style({
  aspectRatio: "16/9",
});

export const tooltipListStyle = style({
  gap: theme.spacings.xxs,
});

export const tooltipListItemStyle = style({
  gap: theme.spacings.xxs,
  alignItems: "center",
  width: "100%",
});

export const tooltipBulletStyle = style({
  borderRadius: "50%",
  height: theme.spacings.xs,
  width: theme.spacings.xs,
});

export const tooltipListItemNameStyle = style({
  flexGrow: 1,
  textAlign: "left",
});

export const legendStyle = style({
  gap: theme.spacings.s,
  ...responsive({
    base: {
      flexDirection: "column",
    },
    s: {
      flexDirection: "row",
    },
  }),
});

export const legendItemStyle = style({
  gap: theme.spacings.xxs,
});
